// extracted by mini-css-extract-plugin
module.exports = {"global_loading":"global_loading","animation-rotating":"animation-rotating","Rotate":"Rotate","refreshBtn":"refreshBtn"};